import React from 'react';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import banner from '../../../../Assets/Linkages/WorldSpaceWeek/World-Space-Week-Banner.jpg';
import WorldSpaceWeekIntroduction from './WorldSpaceWeekIntroduction';
import WorldSpaceWeekLegacy from './WorldSpaceWeekLegacy';
import WorldSpaceWeekVideos from './WorldSpaceWeekVideos';
import WorldSpaceWeekMediaCoverage from './WorldSpaceWeekMediaCoverage';
import WorldSpaceWeekSocialFeed from './WorldSpaceWeekSocialFeed';
import '../../../../Styles/Linkages&Outreach.css';

const WorldSpaceWeek = () => (
  <>
    <AppHeader />
    <main className="world-space-week-page">
      <section className="world-space-week-hero" aria-label="World Space Week">
        <img
          className="world-space-week-banner"
          src={banner}
          alt="World Space Week"
        />
      </section>
      <WorldSpaceWeekIntroduction />
      <WorldSpaceWeekLegacy />
      <WorldSpaceWeekVideos />
      <WorldSpaceWeekMediaCoverage />
      <WorldSpaceWeekSocialFeed />
    </main>
    <FooterComponent />
  </>
);

export default WorldSpaceWeek;
